import React from 'react';
import { getBlogPosts, queryPageData } from 'lib/dato-request';
import { ConversionPanel } from 'components/ConversionPanel';
import { FeaturedPost } from 'components/Blog/FeaturedPost';
import { ArchivePostSection } from 'components/Blog/ArchivePostSection';
import SecondaryPageLayout from '@/components/ReusableUI/SecondaryPageLayout';
import ParentsCTA from '@/components/Parents/ParentsCTA';
import { MUZOLOGY_APP, MUZOLOGY_SIGNUP_URL } from '@/lib/defaults';

const featBlogPost = {
    title: 'Muzology uses music, videos to hold students’ attention and interest',
    description:
        'Check out this feature on Muzology in the Arkansas Democrat-Gazette. As sixth-grade teacher, De-Marcus Burks, says in the article, "It was mind-blowing for me. It makes learning fun and correlates with what I teach every day. And it\'s hip.',
    featuredImage: {
        url: '/assets/graphics/blog-feat.png'
    },
    url: '/blog/muzology-uses-music-videos-to-hold-students-attention-and-interest'
};

const Blog = ({ data, posts }) => {
    const { page, seo } = data;
    const { components } = page;
    const visiblePosts = posts.allBlogPosts.filter((post) => post.visible);
    const featuredPost = visiblePosts.find((post) => post.featured);
    return (
        <SecondaryPageLayout page={page} components={[components[1], components[2]]}>
            <div className='blog'>
                <div className='blog--banner'>
                    <div className='blog--banner-wrapper'>
                        <div className='blog--banner-content'>
                            <h1>{components[0].heading}</h1>
                            <p>{components[0].subhead}</p>
                        </div>
                    </div>
                </div>
                {featuredPost && <FeaturedPost {...featuredPost} url={`/blog/${featuredPost.slug}`} />}
                <div style={{ background: 'linear-gradient(180deg, #F9F8FF 0%, #E6E3FF 59.9%)' }}>
                    <ParentsCTA
                        headline='Try Muzology FREE with your child!'
                        text='Get started now with a 7-day free trial'
                        buttonText='Get Started Now'
                        buttonClassName='dark-button'
                        buttonLink={MUZOLOGY_SIGNUP_URL}
                    />
                </div>

                <ArchivePostSection posts={visiblePosts} />

                {/*
                <TestimonialCarousel testimonials={components[1].testimonials} />
                <FormCardPanel
                    heading={components[2].heading}
                    subhead={components[2].subhead}
                />
                */}
            </div>
            <style jsx>
                {`
                    .blog {
                        .blog--banner {
                            background: linear-gradient(180deg, #f1f7f9 0%, #daeaf9 100%);
                        }

                        .blog--banner-wrapper {
                            padding: 179px 60px 102px;
                            text-align: center;
                            background-image: url('/assets/backgrounds/blog-bg.svg');
                            background-size: contain;
                            background-repeat: no-repeat;
                            background-position: center;

                            .blog--banner-content {
                                max-width: 680px;
                                margin: 0 auto;

                                h1 {
                                    font-weight: 800;
                                    font-size: 48px;
                                    line-height: 55px;
                                    text-align: center;
                                    color: #121651;
                                    margin: 0;
                                }

                                p {
                                    font-weight: 500;
                                    font-size: 18px;
                                    line-height: 25px;
                                    text-align: center;
                                    color: #4f4f4f;
                                    max-width: 511px;
                                    margin: 40px auto 0;
                                }
                            }
                        }

                        .blog--bloglist {
                            max-width: 1100px;
                            margin: 0 auto;
                            padding: 48px 60px;

                            img {
                                max-width: 200px;
                            }
                        }
                    }

                    @media (max-width: 992px) {
                        .blog {
                            .blog--banner-wrapper {
                                padding: 120px 40px;
                            }
                        }
                    }

                    @media (max-width: 768px) {
                        .blog {
                            .blog--banner-wrapper {
                                background-image: url('/assets/backgrounds/blog-mobile-bg.svg');
                                background-position: center 80px;
                                background-size: auto;
                                padding: 145px 40px 80px;

                                .blog--banner-content {
                                    h1 {
                                        font-size: 28px;
                                        line-height: 120%;
                                    }

                                    p {
                                        margin-top: 20px;
                                    }
                                }
                            }
                        }
                    }

                    @media (max-width: 480px) {
                        .blog {
                            .blog--banner-wrapper {
                            }
                        }
                    }
                `}
            </style>
        </SecondaryPageLayout>
    );
};

export async function getStaticProps() {
    const data = await queryPageData('Blog');
    const posts = await getBlogPosts();
    // const visiblePosts = posts.filter((post) => post.visible);
    const visiblePosts = posts;
    return {
        props: { data, posts: visiblePosts }
    };
}

export default Blog;
